export enum ComparisonOperator {
    Equal = 0,
    LessThan = 1,
    LessThanEqual = 2,
    GreaterThan = 3,
    GreaterThanEqual = 4
}